import React from "react";
import "./cover-enterprises.scss";
import { Link } from "gatsby";
import { findRel } from "../../../shared/utils/stringUtilities";

const CoverEnterprises = (props) => {
  const cover = props;

  const isHttp = (url?: string) => {
    return url?.startsWith("http");
  };

  const raw = JSON.parse(cover?.descripcion?.raw);

  return (
    <div className="a-coverEnterprises">
      <div className="a-coverEnterprises-container">
        <div>
          <div className="a-coverEnterprises-container__cover">
            <img
              src={cover.imagenHeader?.gatsbyImageData}
              alt={cover.imagenHeader.title}
            />
          </div>
          <div className="a-coverEnterprises-container__desc">
            <a href="#">{cover.tituloSpan}</a>
            <p className="a-coverEnterprises-container__desc-h1">
              {cover.tituloPrincipal}
            </p>
            {/*<p className="a-coverEnterprises-container__desc-p">
              {cover.descripcion &&
                cover.descripcion.json.content[0]?.content[0]?.content[0]
                  ?.content[0]?.value}
              </p>*/}
          </div>
          <div className="a-coverEnterprises-container__foot hide-on-mobile">
            <p>
              <strong>
                {cover.descripcion &&
                  raw.content[0]?.content[0]?.content[0]?.content[0]?.value}
              </strong>
              {cover.descripcion &&
                raw.content[0]?.content[0]?.content[0]?.content[1]?.value}
              <span>
                {cover.descripcion &&
                  raw.content[0]?.content[0]?.content[0]?.content[2]?.value}
              </span>
            </p>
            <div className="linea" />
            <p className="a-coverEnterprises-container__foot-desc">
              {cover.descripcion &&
                raw.content[0]?.content[1]?.content[0]?.content[0]?.value}
            </p>
            <div className="a-cover-buttons">
              {raw.content[0].content.map((ele, idx) => {
                if (idx > 1) {
                  return (
                    <Link
                      to={`${ele.content[0]?.content[1]?.data?.uri}`}
                      rel={findRel(ele.content[0]?.content[1]?.data?.uri)}
                      target={
                        isHttp(ele.content[0]?.content[1]?.data?.uri)
                          ? "_blank"
                          : "_self"
                      }
                      className={`a-cover-buttons-btn`}
                    >
                      <h3>{ele.content[0]?.content[0].value}</h3>
                    </Link>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoverEnterprises;
